import type { FirestoreSearchUser } from '../firestore/SearchUser'
import type { FirebaseRepository } from '../models/FirebaseRepository'
import { PublicUser } from '../models/PublicUser'

export class SearchUser {
  repository: FirebaseRepository
  id: string

  data: FirestoreSearchUser

  publicUser: PublicUser

  constructor(
    repository: FirebaseRepository,
    id: string,
    data: FirestoreSearchUser
  ) {
    this.repository = repository
    this.id = id
    this.data = data
    this.publicUser = PublicUser.empty(repository).replaceData(data)
  }

  get fullName(): string {
    return `${this.data.firstNameCased} ${this.data.lastNameCased}`.trim()
  }
}
